/**
 * @brisa/ui · VibePill
 *
 * Toggle pill (CAPS micro tracking -0.02em). Limit 3 selected.
 * Tentar 4ª → shake 200ms + microcopy "Escolha até 3".
 */
import * as React from 'react';

export type Vibe = 'social' | 'calmo' | 'cultural' | 'artistico' | 'musical' | 'gastronomico';

export interface VibePillProps {
  vibe: Vibe;
  label: string;
  selected: boolean;
  disabled?: boolean;
  onToggle: (vibe: Vibe) => void;
}

export function VibePill({ vibe, label, selected, disabled = false, onToggle }: VibePillProps) {
  const [shaking, setShaking] = React.useState(false);
  const handleClick = () => {
    if (disabled && !selected) {
      setShaking(true);
      setTimeout(() => setShaking(false), 220);
      return;
    }
    onToggle(vibe);
  };
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      aria-disabled={disabled && !selected}
      onClick={handleClick}
      data-event="vibe-toggled"
      data-vibe={vibe}
      data-selected={selected}
      data-shaking={shaking ? 'true' : 'false'}
      className="brisa-vibe-pill"
    >
      {label}
    </button>
  );
}
